import { createContext } from 'react';
import EditProductCategoriesContext from 'types/contexts/EditProductCategoriesContext';

export default createContext({} as EditProductCategoriesContext);
